/* eslint-disable */
import { Injectable } from '@angular/core';
import { Util } from '@libs/utilities/util';
import { AbstractExtensionPattern } from '@libs/libraries/shared';

import { NgCustomizableSliderComponent } from '../customizable-slider.component';
import { NgSliderElementDirective } from '../directives/slider-element.directive';
import { EnumNgLabelType, EnumNgPointerType } from '../shared/customizable-slider.interface';


@Injectable()
export class NgSliderHandlerExtension extends AbstractExtensionPattern<NgCustomizableSliderComponent> {

	/**------------------------------------------------------
	 * Element Handlers
	 */
	manageElementsStyle() {

		//0 - update scale and set floor and ceil label
		this.updateScale();
		this.main.floorLabelElement.setAlwaysHide(this.main.viewOptions.showTicksValues! || this.main.viewOptions.hideLimitLabels!);
		this.main.ceilLabelElement.setAlwaysHide(this.main.viewOptions.showTicksValues || this.main.viewOptions.hideLimitLabels!);

		//1 - update ticks and label element
		const hideLabelsForTicks: boolean = this.main.viewOptions.showTicksValues! && !this.main.intermediateTicks;
		this.main.minHandleLabelElement.setAlwaysHide(hideLabelsForTicks || this.main.viewOptions.hidePointerLabels!);
		this.main.maxHandleLabelElement.setAlwaysHide(hideLabelsForTicks || !this.main.range || this.main.viewOptions.hidePointerLabels!);
		this.main.combinedLabelElement.setAlwaysHide(hideLabelsForTicks  || !this.main.range || this.main.viewOptions.hidePointerLabels!);
		this.main.selectionBarElement.setAlwaysHide(!this.main.range && !this.main.viewOptions.showSelectionBar);
		this.main.leftOuterSelectionBarElement.setAlwaysHide(!this.main.range  || !this.main.viewOptions.showOuterSelectionBars);
		this.main.rightOuterSelectionBarElement.setAlwaysHide(!this.main.range || !this.main.viewOptions.showOuterSelectionBars);

		//2 - update class element
		this.main.fullBarTransparentClass 	 = this.main.range && this.main.viewOptions.showOuterSelectionBars!;
		this.main.selectionBarDraggableClass = this.main.viewOptions.draggableRange! && !this.main.viewOptions.onlyBindHandles;
		this.main.ticksUnderValuesClass 	 = this.main.intermediateTicks! && this.main.options.showTicksValues!;

		//3 - update class on vertical slider
		if (this.main.sliderElementVerticalClass !== this.main.viewOptions.vertical) {
			this.updateVerticalState();
			setTimeout(() => { this.main.sliderValueUpdateExtension.resetSlider() })
		}

		//4 - update slider element class and update rotation
		if (this.main.sliderElementAnimateClass !== this.main.viewOptions.animate) {setTimeout(() => { this.main.sliderElementAnimateClass = this.main.viewOptions.animate!; })}
		this.updateRotate();
	}

	//** Manage event listeners */
	manageEventsBindings() {
		if (this.main.viewOptions.disabled || this.main.viewOptions.readOnly) this.main.unbindEvents();
			else this.main.bindEvents();
	}

	//** Update slider disable state */
	updateDisabledState() {
		this.main.sliderElementDisabledAttr = this.main.viewOptions.disabled ? 'disabled' : null!;
	}

	//** Update arial label */
	updateAriaLabel() {
		this.main.sliderElementAriaLabel = this.main.viewOptions.ariaLabel || 'nxg-slider';
	}

	updateVerticalState() {

		//0 - update vertical class
		this.main.sliderElementVerticalClass = this.main.viewOptions.vertical!;

		//1 - set element vertical
		for (const element of this.getAllSliderElements()) {
			if (Util.Basic.isDefined(element)) element.setVertical(this.main.viewOptions.vertical!);
		}
	}

	//** Get slider element */
	getAllSliderElements(): NgSliderElementDirective[] {
		return [
			this.main.leftOuterSelectionBarElement,
			this.main.rightOuterSelectionBarElement,
			this.main.fullBarElement,
			this.main.selectionBarElement,
			this.main.minHandleElement,
			this.main.maxHandleElement,
			this.main.floorLabelElement,
			this.main.ceilLabelElement,
			this.main.minHandleLabelElement,
			this.main.maxHandleLabelElement,
			this.main.combinedLabelElement,
			this.main.ticksElement
		];
	}


	/**------------------------------------------------------
	 * Initialize Handlers
	 */
	initHandles() {

		//0 - update slider low handle
		this.updateLowHandle(this.main.sliderHelperExtension.valueToPosition(this.main.viewLowValue));

		//1 - on range update high handle and selection bar
		if (this.main.range) this.updateHighHandle(this.main.sliderHelperExtension.valueToPosition(this.main.viewHighValue));
		this.main.sliderValueUpdateExtension.updateSelectionBar();

		//2 - on range update high handle and selection tick
		if (this.main.range) this.main.sliderValueUpdateExtension.updateCombinedLabel();
		this.main.sliderTickHelperExtension.updateTicksScale();
	}

	updateHandles(which: EnumNgPointerType, newPos: number) {

		//0 - update low and hight handle
		if (which === EnumNgPointerType.Min) this.updateLowHandle(newPos);
		else if (which === EnumNgPointerType.Max) this.updateHighHandle(newPos);

		//1 - update selection and tick scale
		this.main.sliderValueUpdateExtension.updateSelectionBar();
		this.main.sliderTickHelperExtension.updateTicksScale();
		if (this.main.range) this.main.sliderValueUpdateExtension.updateCombinedLabel();
	}

	updateLowHandle(newPos: number) {

		//0 - update position and value
		this.main.minHandleElement.setPosition(newPos);
		this.main.minHandleLabelElement.setValue(this.main.sliderHelperExtension.getDisplayValue(this.main.viewLowValue, EnumNgLabelType.Low));
		this.main.minHandleLabelElement.setPosition(this.getHandleLabelPos(EnumNgPointerType.Min, newPos));

		//1 - update pointer style and label visibility
		if (Util.Basic.isDefined(this.main.viewOptions.getPointerColor)) this.main.minPointerStyle = { backgroundColor: this.getPointerColor(EnumNgPointerType.Min)};
		if (this.main.viewOptions.autoHideLimitLabels) this.main.sliderValueUpdateExtension.updateFloorAndCeilLabelsVisibility();
	}

	updateHighHandle(newPos: number) {

		//0 - update position and value
		this.main.maxHandleElement.setPosition(newPos);
		this.main.maxHandleLabelElement.setValue(this.main.sliderHelperExtension.getDisplayValue(this.main.viewHighValue, EnumNgLabelType.High));
		this.main.maxHandleLabelElement.setPosition(this.getHandleLabelPos(EnumNgPointerType.Max, newPos));

		//1 - update pointer style
		if (Util.Basic.isDefined(this.main.viewOptions.getPointerColor)) this.main.maxPointerStyle = { backgroundColor: this.getPointerColor(EnumNgPointerType.Max)};
		if (this.main.viewOptions.autoHideLimitLabels) this.main.sliderValueUpdateExtension.updateFloorAndCeilLabelsVisibility();
	}

	getNearestHandle(event: MouseEvent|TouchEvent): EnumNgPointerType {

		//0 - return min if no range
		if (!this.main.range) return EnumNgPointerType.Min;

		//1 - update position and distance
		const position	 : number = this.main.sliderHelperExtension.getEventPosition(event);
		const distanceMin: number = Math.abs(position - this.main.minHandleElement.position);
		const distanceMax: number = Math.abs(position - this.main.maxHandleElement.position);

		//2 - return pointer type on distance
		if (distanceMin < distanceMax) return EnumNgPointerType.Min;
		else if (distanceMin > distanceMax) return EnumNgPointerType.Max;
		else if (!this.main.viewOptions.rightToLeft) return position < this.main.minHandleElement.position ? EnumNgPointerType.Min : EnumNgPointerType.Max;

		//3 - return pointer type on position type
		return position > this.main.minHandleElement.position ? EnumNgPointerType.Min : EnumNgPointerType.Max;
	}

	/**------------------------------------------------------
	 * Helper Function
	 */
	private updateScale() {
		for (const element of this.getAllSliderElements()) element.setScale(this.main.viewOptions.scale!);
	}

	private updateRotate() {
		for (const element of this.getAllSliderElements()) element.setRotate(this.main.viewOptions.rotate!);
	}

	private getHandleLabelPos(labelType: EnumNgPointerType, newPos: number): number {

		//0 - update position and dimension
		const labelDimension: number = (labelType === EnumNgPointerType.Min) ? this.main.minHandleLabelElement.dimension : this.main.maxHandleLabelElement.dimension;
		const nearHandlePos : number = newPos - labelDimension / 2 + this.main.handleHalfDimension;
		const endOfBarPos 	: number = this.main.fullBarElement.dimension - labelDimension;

		//1 - return near handle pos
		if (!this.main.viewOptions.boundPointerLabels) return nearHandlePos;

		//2 - return label pos
		if ((this.main.viewOptions.rightToLeft && labelType === EnumNgPointerType.Min) || (!this.main.viewOptions.rightToLeft && labelType === EnumNgPointerType.Max)) return Math.min(nearHandlePos, endOfBarPos);
			else return Math.min(Math.max(nearHandlePos, 0), endOfBarPos);
	}

	private getPointerColor(pointerType: EnumNgPointerType): string {

		//0 - get pointer color for max
		if (pointerType === EnumNgPointerType.Max) {
			return this.main.viewOptions.getPointerColor!(
				this.main.highValue,
				pointerType
			);
		}

		//1 - pointer color for min
		return this.main.viewOptions.getPointerColor!(
			this.main.value,
			pointerType
		);
	}
}
